import {Axios} from '../axios/axios.js'
//登录
export const getLogin = (e) => {
  return Axios({
    url:"/index.php/Login/index",
    method:'put',
    data:e
  })
}
//修改密码
export const changePassWord = (e) => {
  return Axios({
    url:"/index.php/user/change_password",
    method:'put',
    data:e
  })
}
//获取用户信息
export const getUserMessage = (e) => {
  return Axios({
    url:"/index.php/user/get_user_info",
    method:'put',
    data:e
  })
}
//修改头像
export const getAvatar = (e) => {
  return Axios({
    url:"/index.php/user/edit_user_avatar",
    method:'post',
    data:e
  })
}
//编辑用户信息
export const editUserMessage = (e) => {
  return Axios({
    url:"/index.php/user/edit_user_info",
    method:'put',
    data:e
  })
}
//删除用户头像
export const deleteAvatar = (e) => {
  return Axios({
    url:"/index.php/user/del_user_avatar",
    method:'put',
    data:e
  })
}
//test/error_log
export const errorLog = (e) => {
  return Axios({
    url:"/test/error_log",
    method:'put',
    data:e
  })
}
